module.exports = __webpack_public_path__ + "img/manage-cand-icon.598297dc.svg";